import { combineReducers } from "redux";

import { authReducer } from "../../pages/auth/reducer";
import { announcementReducer } from "../../pages/admin/Announcement/reducer";
import { announcementUserReducer } from "../../pages/default/Announcements/reducer";
import { hashtagReducer } from "../../pages/admin/Hashtag/reducer";
import { uiReducer } from "../../UISettings/reducer";
import { reportingImageReducer } from "../../pages/admin/ReportingImage/reducer";


export const rootReducer = combineReducers({
    auth: authReducer,
    ui: uiReducer,
    announcement: announcementReducer,
    announcementUser: announcementUserReducer,
    hashtag: hashtagReducer,
    reportingImage: reportingImageReducer
});

export type RootState = ReturnType<typeof rootReducer>;